import React, { useState, useEffect } from "react";

// ASSETS
import Agenda from "assets/svg/IllAgendaWeb.svg";

// STYLES
import {
  AgendaTextWrapper,
  DescriptionWrapper,
  DownloadButtonContainer,
  Image,
  PartnerDetailsContainer,
  PartnerDetailsIconContainer,
  PartnerDetailsTextContainer,
  SmallAgendaContainer,
  SmallContainer,
  ThirdColumnContainer,
} from "./TeamDetailsStyled";

// LIBRARIES

// MISC
import { IProps } from "./TeamDetailsModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import PersonnelCard from "components/PersonnelCard/PersonnelCard";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutes } from "config/AppRoutesConfig";

const TeamDetails = (props: IProps) => {
  // PROPERTIES
  const { item } = props;

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const navigate = useNavigate();

  // STATE CONSTANTS
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // EVENT HANDLERS

  const handleDownload = () => {
    if (item?.CV) {
      window.open(item.CV, "_blank");
    } else {
      console.error("CV file is not available");
    }
  };

  return (
    <PartnerDetailsContainer>
      <PartnerDetailsIconContainer>
        <PersonnelCard
          image={item?.image}
          fullName={item?.fullName}
          occupation={item?.occupation}
        />
      </PartnerDetailsIconContainer>
      <PartnerDetailsTextContainer>
        <DescriptionWrapper>
          <CustomText
            text={item?.bio || t("components.modal.team.noDescription")}
            type={TextType.P1}
            color={COLORS.Background}
          />
        </DescriptionWrapper>
      </PartnerDetailsTextContainer>
      <ThirdColumnContainer>
        <SmallContainer>
          <CustomText
            text={t("components.modal.team.audience")}
            type={TextType.H4}
            color={COLORS.Background}
          />
          <CustomText
            text={item?.audience || "-"}
            type={TextType.H4}
            color={COLORS.Background}
          />
        </SmallContainer>

        <SmallContainer>
          <CustomText
            text={"CV"}
            type={TextType.H4}
            color={COLORS.Background}
          />
          <DownloadButtonContainer>
            <ButtonAtom
              type={ButtonType.ArrowDownRed}
              text={t("view.newsAndMedia.download")}
              arrowDown={true}
              rightIcon={true}
              onClick={handleDownload}
            />
          </DownloadButtonContainer>
        </SmallContainer>

        {item?.order === 0 && (
          <SmallAgendaContainer onClick={() => navigate(appRoutes.agenda)}>
            <AgendaTextWrapper>
              <CustomText
                text={t("components.modal.team.dsuChief")}
                type={TextType.H4}
                color={COLORS.RaisinBlack}
              />
            </AgendaTextWrapper>
            <Image src={Agenda} />
          </SmallAgendaContainer>
        )}
      </ThirdColumnContainer>
    </PartnerDetailsContainer>
  );
};

export default TeamDetails;
